import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';
import { Message } from '@/modules/messenger/_modules/message/models/Message';
import { User } from '@/modules/user/models/User';
import { MessageTemplateType } from '@/modules/messenger/_modules/message/constants/MessageTemplateType';

export class MessageTemplate extends BaseEntityModel {
  id?: number;
  modelType?: string;
  modelId?: number;
  type?: MessageTemplateType;
  key?: number;
  text?: string;
  frenchText?: string;
  user?: Relationship<User> | null;
  messages?: Relationship<Message[]> | null;

  constructor(model: Partial<MessageTemplate> = {}) {
    super(model);

    this.id = model.id;
    this.modelType = model.modelType;
    this.modelId = model.modelId;
    this.type = model.type;
    this.key = model.key;
    this.text = model.text;
    this.frenchText = model.frenchText;
    this.user = User.mapModelOrNull(model.user);
    this.messages = Message.mapModelsOrNull(model.messages);
  }
}
